import React from 'react';
import './SeekIcon.css';

/**
 * SeekIcon — Skip 10s back/forward icon.
 *
 * Geometry directly adapted from Lucide `RotateCcw` / `RotateCw` (battle-tested):
 * - 270° loop arc with small connector going up
 * - L-elbow at top corner forming a clear "rewind" / "fast-forward" arrowhead
 *
 * The "10" number is overlaid via HTML flexbox for pixel-perfect centering.
 */
function SeekIcon({ direction = 'forward', size = 28 }) {
  const isBack = direction === 'back';

  return (
    <span
      className="seek-icon"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="seek-icon-svg"
      >
        {isBack ? (
          <>
            {/* CCW arc — Lucide RotateCcw geometry */}
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            {/* L-elbow arrow head at top-left */}
            <path d="M3 3v5h5" />
          </>
        ) : (
          <>
            {/* CW arc — Lucide RotateCw geometry (mirror) */}
            <path d="M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            {/* L-elbow arrow head at top-right */}
            <path d="M21 3v5h-5" />
          </>
        )}
      </svg>
      <span className="seek-icon-num">10</span>
    </span>
  );
}

export default SeekIcon;
